module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/11.e38693da.png";